import { combineReducers } from 'redux';
export function stock_configs_reducer(state = {}, action) {
    switch (action.type) {
        case 'LOAD_STOCK_CONFIGS__REQUEST':
            return {
                ...state,
                [action.device_type]: {
                    loading: true,
                    configs: undefined,
                    error: undefined,
                },
            };
        case 'LOAD_STOCK_CONFIGS__OK':
            return {
                ...state,
                [action.device_type]: {
                    loading: false,
                    configs: action.configs,
                    error: undefined,
                },
            };
        case 'LOAD_STOCK_CONFIGS__FAIL':
            return {
                ...state,
                [action.device_type]: {
                    loading: false,
                    configs: undefined,
                    error: action.error,
                },
            };
        default:
            return state;
    }
}
export function apply_stock_config_reducer(state = {}, action) {
    switch (action.type) {
        case 'APPLY_STOCK_CONFIG__REQUEST':
            return {
                ...state,
                [action.device_id]: {
                    loading: true,
                    config_id: action.config_id,
                    success: null,
                    error: undefined,
                    dialog_open: false,
                },
            };
        case 'APPLY_STOCK_CONFIG__OK':
            return {
                ...state,
                [action.device_id]: {
                    loading: false,
                    config_id: action.config_id,
                    success: true,
                    error: undefined,
                    dialog_open: true,
                },
            };
        case 'APPLY_STOCK_CONFIG__FAIL':
            return {
                ...state,
                [action.device_id]: {
                    loading: false,
                    config_id: action.config_id,
                    success: false,
                    error: action.error,
                    dialog_open: true,
                },
            };
        case 'CLOSE_APPLY_STOCK_CONFIG_CONFIRMATION': {
            const existing = state[action.device_id];
            if (existing)
                return {
                    ...state,
                    [action.device_id]: {
                        ...existing,
                        dialog_open: false,
                    },
                };
            return state;
        }
        default:
            return state;
    }
}
export const reducer = combineReducers({
    library: stock_configs_reducer,
    applying: apply_stock_config_reducer,
});
